/**
 * Resolve the owning profile id for a mission (API shape: owner.profileId).
 */
export function getMissionOwnerProfileId(mission) {
  if (!mission) return "";
  const o = mission.owner;
  if (o && typeof o === "object") {
    const id = o.profileId ?? o.ProfileId;
    if (id != null && String(id).trim() !== "") return String(id).trim();
  }
  if (typeof o === "string" && o.trim()) return o.trim();
  const flat =
    mission.ownerProfileId ??
    mission.OwnerProfileId ??
    mission.ownerId ??
    mission.OwnerId;
  if (flat != null && String(flat).trim() !== "") return String(flat).trim();
  return "";
}

export function isMissionOwner(mission, profileId) {
  if (!mission || profileId == null || String(profileId).trim() === "")
    return false;
  const ownerId = getMissionOwnerProfileId(mission);
  if (!ownerId) return false;
  return ownerId === String(profileId).trim();
}

export function isInactiveMissionStatus(missionOrStatus) {
  const status =
    missionOrStatus && typeof missionOrStatus === "object"
      ? missionOrStatus.status
      : missionOrStatus;
  return String(status || "").trim().toLowerCase() === "inactive";
}

/** AviPair Admins (entity AviPair and/or role Admin) can edit any mission. */
export function isAviPairAdmin({ tokenRole, tokenEntityType } = {}) {
  const entity = String(tokenEntityType || "").trim().toLowerCase();
  const role = String(tokenRole || "").trim().toLowerCase();
  return entity === "avipair" || role === "admin";
}

/**
 * Only users operating in the AviPair entity context may assign the
 * AviPair Admin association (role Admin + entityType AviPair).
 */
export function canAssignAviPairAdminRole({ tokenEntityType } = {}) {
  return String(tokenEntityType || "").trim().toLowerCase() === "avipair";
}

/**
 * Only AviPair Admins may add or edit entities (nonprofits / airports).
 * Users, NonProfits, and Airports are view-only.
 */
export function canManageEntities({ tokenEntityType, isGuest } = {}) {
  if (isGuest) return false;
  return String(tokenEntityType || "").trim().toLowerCase() === "avipair";
}

export function isAviPairAdminAssociation(association) {
  if (!association || typeof association !== "object") return false;
  return String(association.entityType || "").trim().toLowerCase() === "avipair";
}

export function canEditMissionForProfile(
  mission,
  { profileId, isGuest } = {},
) {
  if (!mission || isGuest) return false;
  if (isInactiveMissionStatus(mission)) return false;
  return isMissionOwner(mission, profileId);
}
